import { HttpClient } from '@angular/common/http';
import { DealerInfoModel } from './dealer-info.model';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DealerInfoService = /** @class */ (function () {
    function DealerInfoService(http) {
        this.http = http;
    }
    DealerInfoService.prototype.getDealers = function (q) {
        var params = {
            q: q
        };
        return this.http.get('dealers/info/', { params: params })
            .pipe(map(function (response) { return response ? response.map(function (element) { return DealerInfoModel.fromJSON(element); }) : null; }));
    };
    DealerInfoService.ngInjectableDef = i0.defineInjectable({ factory: function DealerInfoService_Factory() { return new DealerInfoService(i0.inject(i1.HttpClient)); }, token: DealerInfoService, providedIn: "root" });
    return DealerInfoService;
}());
export { DealerInfoService };
